import HttpService from './baseHttp'

//   商品管理
export const HttpProductManageList = (data = {}) => HttpService.get('/api/v2/productManage/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
//   商品管理导出
export const HttpExportProductManage = (data = {}, config = {}) => HttpService.get('/api/v2/productManage/export', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS, ...config })
//   商品管理详情
export const HttpProductManage = (data = {}) => HttpService.get('/api/v1/Product/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
//   推送仓库
export const HttpPushProductManage = (data = {}) => HttpService.get('/api/v2/productManage/pushHouse', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 识别码查询
export const HttpInventoryCodeMap = (data = {}) => HttpService.get("/api/v2/inventory/codeMap/findBySku", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 导入
export const HttpImportProduct = (data = {}, config = {}) => HttpService.post("/api/v2/productManage/import", data, { ...config, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 导入产品估值
export const HttpImportProductValue = (data = {}, config = {}) => HttpService.post("/api/v2/productManage/import/price", data, { ...config, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 产品估值模板
export const HttpDownloadProductValueTemplate = (data = {},config) => HttpService.get("/api/v2/productManage/excel/price", { ...config,params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

//编辑拣货
export const HttpUpdateProductPick = (data = {}) => HttpService.get("/api/v2/productManage/editPick", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 下载模板
export const HttpDownloadProductTemplate = (data = {},config) => HttpService.get("/api/v2/productManage/excel", { ...config,params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 批量操作的接口

export const HttpGetBtachAllAction = (data = {}, config) => HttpService.get('/api/v1/Product/batch/check', { params: data })

// 获取标签数字
export const HttpGetProductNumber = (data = {}, config) => HttpService.get('/api/v1/Product/findStatusNum', { params: data })

// 忽略异常
export const HttpGetBtachYichang = (data = {}, config) => HttpService.get('/api/v1/Product/batch/pass', { params: data})



// listing

export const HttpListingList = (data = {}) => HttpService.get('/api/v2/amazon_product_listing/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpGetListingOne = (data = {}) => HttpService.get('/api/v2/amazon_product_listing/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpbatchSetVirtual = (data = {}) => HttpService.get('/api/v2/amazon_product_listing/batchSetVirtual', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpbatchCreateProduct = (data = {}) => HttpService.get('/api/v2/amazon_product_listing/batchCreateProductChannel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// lineMaintain
export const HttpLineMaintainList = (data = {}) => HttpService.get('/api/v1/ProductLineTarget/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpGetLineMaintainOne = (data = {}) => HttpService.get('/api/v1/ProductLineTarget/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpDeleteLineMaintain = (data = {}) => HttpService.get('/api/v1/ProductLineTarget/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpSaveLineMaintain = (data = {}) => HttpService.post("/api/v1/ProductLineTarget/save", data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })